<!-- progress -->
<div id="loading-container" class="progress-container" [ngClass]="topScreen ? 'position-top' : ''" *ngIf="systemService.loading$ | async">
  <div class="progress-material">
    <div class="indeterminate"></div>
  </div>          
</div>